<template>
  <div class="mgt-100">
    <!-- {{contents}} -->
    <img src="/images/board/no-board-data.svg" alt="" class="edm-nodata mgx-auto mgb-24" v-if="contents == ''">
    <div v-if="contents != ''">
          <div class="t-center t-headline8 t-line-h-28 font-r">{{$t('3128')}}</div>
          <div class="t-center t-body1 mgt-4 t-line-h-28 font-r t-color-bodyGrayA">{{$t('3129')}}</div> 
         
    </div>
    <div v-else-if="(filterCategory || selectedMenuType=='MINE')">
          <div class="t-center t-headline8 t-line-h-28 font-r">{{$t('3336')}}</div>
          <div class="t-center t-body1 mgt-4 t-line-h-28 font-r t-color-bodyGrayA">{{$t('3337')}}</div> 
         
    </div>
    <div v-else>
      <div class="t-center t-headline8 t-line-h-28 font-r">{{$t('3339')}}</div>
      <div class="t-center t-body1 mgt-4 t-line-h-28 font-r t-color-bodyGrayA">{{$t('3340')}}</div>
    </div> 
  </div>
</template>

<script>
import DisplayFile from '../socialLearning/DisplayFile.vue';
// Components/Mixin/Extend/API define



export default {
  props:['filterCategory','selectedMenuType', 'contents'],
  name: "",
  data() {
    return {
    };
  },
  components: {
    DisplayFile
    
  },
  watch: {
    $route(to, from) {},
  },
};
</script>

<style scoped>
.no-board-data img {
    height: 143px;
    width: auto;
}
</style>